import { createContext, useContext, useState, useCallback } from "react";

const DICT = {
  it: {
    periodicity: "Periodicità:",
    monthly: "Mensile",
    reg: "Reg. Trib. Rimini N.5",
    latest: "Ultim'ora",
    dateLocale: "it-IT",
    back: "Indietro",
    readTime: "min di lettura",
    issueLabel: "Numero:",
    videoOnIg: "Video su Instagram",
    watchInterview: "Guarda il video-intervista",
    igReel: "Apri il reel sul profilo Instagram ufficiale del Legend Team",
    withSupport: "Con il supporto di",
    continueReading: "Continua a leggere",
    loading: "Caricamento…",
    calTitle: "Calendario Motorsport 2026",
    calSub: "Rally italiani ed europei, F1, MotoGP, auto e moto storiche, drift, slalom, pista, fiere e raduni d'epoca. Ogni evento riporta le fonti ufficiali, i siti e i biglietti quando disponibili. Usa i filtri.",
    upcomingRaces: "Prossimi eventi",
    pastRaces: "Eventi disputati",
    noUpcoming: "Nessun evento in programma al momento.",
    program: "Programma",
    watchLive: "Guarda la diretta su Instagram",
    readArticle: "Leggi l'articolo",
    officialSite: "Sito ufficiale",
    ticketsLabel: "Biglietti / Prezzi",
    registerBy: "Iscriviti (entro",
    allEvents: "Tutti",
    hqTitle: "Sede Legend Team",
    sourceLabel: "Fonte / Locandina",
  },
  en: {
    periodicity: "Frequency:",
    monthly: "Monthly",
    reg: "Reg. Court of Rimini No.5",
    latest: "Breaking",
    dateLocale: "en-GB",
    back: "Back",
    readTime: "min read",
    issueLabel: "Issue:",
    videoOnIg: "Video on Instagram",
    watchInterview: "Watch the video interview",
    igReel: "Open the reel on the Legend Team's official Instagram profile",
    withSupport: "Supported by",
    continueReading: "Continue reading",
    loading: "Loading…",
    calTitle: "2026 Motorsport Calendar",
    calSub: "Italian and European rallies, F1, MotoGP, historic cars & bikes, drift, slalom, track days, expos and classic meetings. Every event lists official sources, websites and tickets when available. Use the filters.",
    upcomingRaces: "Upcoming events",
    pastRaces: "Past events",
    noUpcoming: "No events scheduled at the moment.",
    program: "Schedule",
    watchLive: "Watch the live stream on Instagram",
    readArticle: "Read the article",
    officialSite: "Official site",
    ticketsLabel: "Tickets / Prices",
    registerBy: "Register (by",
    allEvents: "All",
    hqTitle: "Legend Team HQ",
    sourceLabel: "Source / Poster",
  },
};

export function localizeRace(r, lang) {
  if (!r || lang !== "en") return r;
  return { ...r, name: r.name_en || r.name, category: r.category_en || r.category };
}

export function localizeArticle(a, lang) {
  if (!a || lang !== "en") return a;
  return {
    ...a,
    title: a.title_en || a.title,
    subtitle: a.subtitle_en || a.subtitle,
    excerpt: a.excerpt_en || a.excerpt,
    body: a.body_en || a.body,
    gallery: (a.gallery || []).map((g) => ({ ...g, caption: g.caption_en || g.caption })),
  };
}

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("legend_lang") || "it");
  const setLang = useCallback((l) => {
    setLangState(l);
    localStorage.setItem("legend_lang", l);
  }, []);
  const t = useCallback((key) => (DICT[lang] && DICT[lang][key]) || DICT.it[key] || key, [lang]);
  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext) || { lang: "it", setLang: () => {}, t: (k) => (DICT.it[k] || k) };
